import { EditButton, List, ShowButton, useDataGrid } from '@refinedev/mui';
import React from 'react';
import { DataGrid, type GridColDef } from '../../../components/DataGrid.tsx';
import { useColumnVisibilityModel } from '../../../hooks/columnVisibilityModel.ts';
import { Author } from '../../../types/index.ts';

export const AuthorList = () => {
  const { dataGridProps, filters, setFilters } = useDataGrid<Author>({
    resource: 'contents/authors',
    queryOptions: {
      select({ data, total }) {
        return {
          data: data.map((row) => Author.parse(row)),
          total,
        };
      },
    },
  });

  const columns = React.useMemo<Array<GridColDef<Author>>>(
    () => [
      {
        type: 'actions',
        field: 'actions',
        maxWidth: 80,
        renderCell({ row }) {
          return (
            <>
              <EditButton hideText recordItemId={row.id} />
              <ShowButton hideText recordItemId={row.id} />
            </>
          );
        },
      },
      {
        field: 'name',
        flex: 1,
        headerName: '名前',
      },
      {
        field: 'jobTitle',
        flex: 1,
        headerName: '役職',
      },
      {
        field: 'description',
        flex: 2,
        headerName: 'プロフィール',
      },
      {
        type: 'dateTime',
        field: 'createdAt',
        headerName: '作成日時',
        display: 'flex',
        minWidth: 150,
        valueFormatter(_, { createdAt }) {
          if (!createdAt) return '-';
          return createdAt.toLocaleString('ja-JP').replace(/:\d{2}$/, '');
        },
      },
      {
        field: 'createdBy',
        headerName: '作成者',
        display: 'flex',
        minWidth: 150,
        valueGetter(_, row) {
          return row.createdBy ?? '-';
        },
      },
      {
        type: 'dateTime',
        field: 'modifiedAt',
        headerName: '変更日時',
        display: 'flex',
        minWidth: 150,
        valueFormatter(_, { modifiedAt }) {
          if (!modifiedAt) return '-';
          return modifiedAt.toLocaleString('ja-JP').replace(/:\d{2}$/, '');
        },
      },
      {
        field: 'modifiedBy',
        headerName: '変更者',
        display: 'flex',
        minWidth: 150,
        valueGetter(_, row) {
          return row.modifiedBy ?? '-';
        },
      },
    ],
    [],
  );

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useColumnVisibilityModel('contents/authors');

  return (
    <List>
      <DataGrid
        {...dataGridProps}
        columns={columns}
        filters={filters}
        setFilters={setFilters}
        filterDebounceMs={800}
        columnVisibilityModel={columnVisibilityModel}
        onColumnVisibilityModelChange={setColumnVisibilityModel}
      />
    </List>
  );
};
